import { post, streamPost } from '@/api/request'
import { getDeviceInfo } from '@/utils/device'
import store from '../../store'
import { RequestOption } from '../request'

export const sendMessage = async (data: any, option: RequestOption) => {
    return streamPost(
        '/api/solve-x-ai/chat/v2/chat/completions',
        {
            requestTime: Date.now(),
            stream: true,
            croppedAttachId: data.originImageId,
            input: data.content || '',
            originAttachId: data.originImageId,
            sessionId: store.getters['chat/sessionId'],
            recommended: data.recommend,
            fastAnswer: store.getters['chat/answerOnTop'],
            deviceInfo: await getDeviceInfo(),
            buttonText: data.buttonText,
            demoId: data.demoId
            // hasFigure: data.hasFigure,TODO
            // "hasTable": data.hasTable,TODO
            // "uploadCostTime": data.uploadCostTime,TODO
            // "recommendCostTime": data.recommendCostTime,TODO
            // hasRecommend: data.hasRecommend,
            // "hasMoved": data.hasMoved
        },
        option
    )
}

export const getChatWelcome = async (option: RequestOption) => {
    return streamPost('/api/solve-x-ai/buddy/greeting', {}, option)
}

export const uploadBase64Image = (base64Image: string, isStaticFile: boolean, option: Omit<RequestOption, 'data'> = {}) => {
    return post(
        '/api/solve-x-ai/file/put-base64?isStaticFile=' + (isStaticFile ? 1 : 0),
        {
            base64Image,
            uploadTimeSpan: Date.now()
        },
        option
    )
}

export const like = (sessionMessageId: number, type: number) => {
    return post('/api/solve-x-ai/chat-session/chat-message-interaction/submit?interactionType=' + (type == 0 ? -1 : type == -1 ? 0 : 1) + '&messageId=' + sessionMessageId)
}

export const plotJsxGraph = (data: { sessionMessageId: string | number }) => {
    return post('/api/solve-x-ai/tools/plot/get-plot-jsxgraph', data, {
        timeout: 4000
    })
}
